import { render, staticRenderFns } from "./TaxCardPdf.vue?vue&type=template&id=7c8e9753&"
import script from "./TaxCardPdf.vue?vue&type=script&lang=js&"
export * from "./TaxCardPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports